var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5965",
    "data-name": "Group 5965",
    transform: "translate(-13469.276 -21597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5964",
    "data-name": "Group 5964",
    transform: "translate(13469.276 21597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M96.2,40.924a8.009,8.009,0,1,1,5.654-2.346A8,8,0,0,1,96.2,40.924Zm0-14.973A6.982,6.982,0,1,0,101.128,28,6.973,6.973,0,0,0,96.2,25.951Z",
    transform: "translate(-88.2 -24.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M331.24,392.922a.642.642,0,1,0,.321-.556A.642.642,0,0,0,331.24,392.922Z",
    transform: "translate(-323.814 -381.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M264.41,134.629a.514.514,0,0,1-.514-.514V133.3a1.932,1.932,0,0,1,.857-1.589,4.828,4.828,0,0,0,.934-.707,1.593,1.593,0,0,0,.428-1.083,1.675,1.675,0,0,0-1.713-1.645,1.632,1.632,0,0,0-1.713,1.6.514.514,0,1,1-1.028,0,2.728,2.728,0,0,1,5.452.047,2.625,2.625,0,0,1-.715,1.8,5.85,5.85,0,0,1-1.178.9c-.244.133-.313.565-.321.707v.8a.514.514,0,0,1-.488.51Z",
    transform: "translate(-256.363 -124.151)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.2ad3473f443be0834c930672c5b23dc3.svg";
export { ForwardRef as ReactComponent };